import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-main-content-wrapper',
    templateUrl: './main-content-wrapper.component.html',
    standalone: false
})
export class MainContentWrapperComponent implements OnInit {
  @Input() isCollapsed: boolean;
  @Input() headerHeight: number;

  constructor() {
  }

  ngOnInit() {
    return;
  }

}
